import { parseReference, resolveId } from "@medplum/core";
import { Patient } from "@medplum/fhirtypes";

/**
 * Reads the practice a Patient belongs to from its Organization compartment.
 * @param patient - Patient to read, if any.
 * @returns The practice Organization id, or undefined when the Patient has no Organization compartment.
 */
export function getPatientPracticeId(patient: Patient | undefined): string | undefined {
  const practiceCompartment = patient?.meta?.compartment?.find(
    (compartment) => parseReference(compartment)?.[0] === "Organization",
  );
  return practiceCompartment ? resolveId(practiceCompartment) : undefined;
}
